"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSendReportToEmailMutation = void 0;

var _EmptyGatewayApi = require("../../EmptyGatewayApi");

var reports = _EmptyGatewayApi.emptyGatewayApi.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      sendReportToEmail: build.mutation({
        query: function query(_ref) {
          var reportType = _ref.reportType,
              filters = _ref.filters,
              email = _ref.email;
          return {
            url: "/reporting/roi/report-to-email/".concat(reportType),
            method: 'POST',
            body: {
              sendToEmail: email,
              filters: filters
            }
          };
        }
      })
    };
  }
});

var useSendReportToEmailMutation = reports.useSendReportToEmailMutation;
exports.useSendReportToEmailMutation = useSendReportToEmailMutation;